export const stepsWebConfig = {
    last_step: 4,
    define_steps: 3,
}

export const stepsCCConfig = {
    last_step: 3,
    define_steps: 2,
}
